define('views/modules/dashboard/dashboard-header',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/i18n',
    // views
    'views/parts/header/default-header',
    'views/parts/form/button',
    // template
    'text!templates/modules/dashboard/dashboard-header.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    i18n,
    // views
    VDefaultHeader,
    VButton,
    // template
    TDashboardHeader
    
) {

    var VDashboardHeader = VDefaultHeader.extend({
        template: TDashboardHeader,

        regions: _.extend({}, VDefaultHeader.prototype.regions, {
            customButton: ".custom-button",
        }),

        initialize: function(options) {
            VDashboardHeader.__super__.initialize.apply(this, arguments);

            var profile = this.profile = options.profile;
            _.extend(this.view, {
                customButton: new VButton({
                    label: profile.get('customButtonText'),
                    callback: this.onClearAllMessages,
                    context: this,
                    url: profile.get('customButtonUrl'),
                    target: '_blank',
                    external: true,
                    icon: false,
                    class: 'btn-rounded btn-sm',
                    skipTranslation: true,
                }),
            });

            this.listenTo(profile, 'sync', this.onProfileSync);
        },

        render: function() {
            VDashboardHeader.__super__.render.apply(this, arguments);
            if (this.profile.get('customButtonActive')) {
                this.assign(this.view.customButton, this.zone.$customButton);
                this.addActiveCustomButtonClass();
            }
        },

        addActiveCustomButtonClass: function() {
            this.$el.addClass('active-custom-button');
        },

        onProfileSync: function(model, options) {
            if (this.view) {
                var button = this.view.customButton;
                button.setLabel(model.get('customButtonText'));
                button.setUrl(model.get('customButtonUrl'));
            }

            this.model.set('title', i18n.t(this.options.title));
            this.model.set('subtitle', i18n.t(this.options.subtitle, {
                name: model.get('firstname')
            }));
        },

    });

    return VDashboardHeader;

});

